import FileAPI from '../../api/file.js'

export const file = {
    namespaced: true,
    state: {
        files: [],
        filesLoadStatus: 0,
    },
    actions: {
        load({ commit }, data) {
            commit('setFilesLoadStatus', 1)
            var request = null
            if (data.examination_id) {
                request = FileAPI.getExaminationFiles(data.patient_id, data.examination_id)
            }
            else {
                request = FileAPI.getPatientFiles(data.patient_id)
            }
            request.then(function (response) {
                commit('setFiles', response.data)
                commit('setFilesLoadStatus', 2)
            })
                .catch(function () {
                    commit('setFiles', {})
                    commit('setFilesLoadStatus', 3)
                });
        },

        add({ commit }, file) {
            commit('addFile', file)
        },

        delete({ state }, data) {
            FileAPI.deleteFile(data.id)
        },

        DOWNLOAD: ({ }, file) => FileAPI.DOWNLOAD(file.id).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = window.document.createElement('a');
            link.href = url;
            link.setAttribute('download', file.filename);
            window.document.body.appendChild(link);
            link.click();
        }).catch(console.log),

    },

    mutations: {
        setFiles(state, files) {
            state.files = files
        },

        setFilesLoadStatus(state, status) {
            state.filesLoadStatus = status
        },

        addFile(state, file) {
            state.files.push(file)
        }
    },

}
